import { render } from "./AddModuloView.vue?vue&type=template&id=2c7f315e&scoped=true"
import script from "./AddModuloView.vue?vue&type=script&lang=js"
export * from "./AddModuloView.vue?vue&type=script&lang=js"

import "./AddModuloView.vue?vue&type=style&index=0&id=2c7f315e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c7f315e"]])

export default __exports__